var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8543 16.1535L12.7656 12.0648C13.778 10.8909 14.3929 9.36468 14.3929 7.69654C14.3929 4.00355 11.3885 1 7.69645 1C4.0044 1 1 4.00444 1 7.69654C1 11.3886 4.0044 14.3931 7.69645 14.3931C9.36457 14.3931 10.8907 13.7782 12.0646 12.7657L16.1533 16.8545C16.25 16.9512 16.3769 17 16.5038 17C16.6307 17 16.7575 16.9512 16.8543 16.8545C17.0486 16.661 17.0486 16.3469 16.8543 16.1535ZM7.69645 13.4011C4.55097 13.4011 1.992 10.8421 1.992 7.69654C1.992 4.55102 4.55097 1.99201 7.69645 1.99201C10.8419 1.99201 13.4009 4.55102 13.4009 7.69654C13.4009 10.8421 10.8419 13.4011 7.69645 13.4011Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.13db1e9d3da87f08165c2875fb8474af.svg";
export { ForwardRef as ReactComponent };